<template>
  <div class="map-background" :style="boxWrapStyleObj">
    <div ref="cityMapRef" :style="mapStyleObj">
      <Row class="dirst-content">
        <Col :xs="{ span: 8 }" :sm="{ span: 8 }" :md="{ span: 8 }" :lg="{ span: 8 }" v-for="(item, index) in data"
          :key="index">
        <div class="distri-item" :title="item.name + '：' + item.value" @click="initDirstMap(item)">
          {{ item.name }}
        </div>
        </Col>
      </Row>
    </div>
    <div class="panel-box-wrap district-box" v-show="isShowProvince">
      <div class="close-btn">
        <img class="logo-img" src="../../../assets/images/map/close.png" width="100%" height="100%"
          v-on:click="closeWin" />
      </div>
      <div class="panel-box">
        <div class="panel-left" ref="panelLeftRef">
          <template v-if="isTowns == '0'">
            <div v-show="currentCode == '320112'" style="width: 100%; height: 100%">
              <div class="jbxq-img"></div>
            </div>
            <div id="district_map" ref="provinceMapRef" class="left-map" v-show="currentCode != '320112'"></div>
          </template>
          <div class="current-area-name" v-else>{{ currentName }}</div>
        </div>
        <div class="district-data-area">
          <div class="popup-item bubble" v-for="(item, index) in districtDataList">
            <div class="popup-item-text" :title="item.value">
              <p class="p-num">
                <!--{{// item.value}}-->
                <count-up class="infor-card-count user-created-count" :id-name="'codes_' + item.name"
                  :end-val="item.value" color="#0EFCFF" countSize="18" :countWeight="countWeight" :isConvert="isConvert">
                </count-up>
              </p>
              <p>{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="panel-right">
          <div class="panel-head">
            <div class="head-wrap">
              <div class="right-mian" style="display: flex">
                <input placeholder="请输入学校名称" class="input-cla" v-model="filters.keyWord"
                  v-on:keyup.enter="handleSearch" />
                <div class="search-btn" v-on:click="handleSearch">
                  <div class="search-icon">
                    <img src="../../../assets/images/databoard/detailPage/search.png" width="100%" height="100%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--按学校统计的学校使用情况列表-->
          <div class="panel-table">
            <div class="header">
              <Col :span="3">
              <span>排序</span>
              </Col>
              <Col :span="10">
              <span>学校名称</span>
              </Col>
              <Col :span="3">
              <span>学段</span>
              </Col>
              <Col :span="4">
              <span>操作次数</span>
              </Col>
              <Col :span="4">
              <span>班级数</span>
              </Col>
            </div>
            <Row class="row-wrap" v-for="(item, index) in schoolUseData" :key="item.id">
              <Col :span="3" class="col-content">
              <div class="sort-item orange-item" :class="(pageParams.page - 1) * pageParams.limit + index++ < 3
                  ? 'orange-item'
                  : 'blue-item'
                ">
                <span>{{
                  (pageParams.page - 1) * pageParams.limit + index++
                }}</span>
              </div>
              </Col>
              <Col :span="10" class="col-content">
              <a :title="item.school_name" href="javascript:void(0);" v-on:click="lookSchoolDashBoard(item.id)"
                style="color: #2d8cf0">{{ item.school_name }}</a>
              </Col>
              <Col :span="3" class="col-content">
              <span>{{ item.phase }}</span>
              </Col>
              <Col :span="4" class="col-content">
              <span>{{ item.ocount }}</span>
              </Col>
              <Col :span="4" class="col-content">
              <span>{{ item.classCount }}</span>
              </Col>
            </Row>
          </div>
          <div class="bottom-page">
            <div class="laypage_main">
              <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                v-if="pageParams.total && pageParams.pageCount > 1"></Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--气泡1-->
    <div class="rate-popup rate-popup-one" :title="totalDistrictDataList[0].value">
      <div class="rate-popup-item">
        <img src="../../../assets/images/nanjindataboard/popup-ratate.png" width="100%" height="100%" class="popup-img" />
        <div class="count">
          <span class="num">
            <count-up class="infor-card-count user-created-count" :id-name="'code_' + '学校总数'"
              :end-val="totalDistrictDataList[0].value" color="#0EFCFF" countSize="18" :countWeight="countWeight"
              :isConvert="isConvert">
            </count-up>
          </span>
          <p>学校总数</p>
        </div>
      </div>
    </div>
    <!--气泡2-->
    <div class="rate-popup rate-popup-two" :title="totalDistrictDataList[1].value">
      <div class="rate-popup-item">
        <img src="../../../assets/images/nanjindataboard/popup-ratate.png" width="100%" height="100%" class="popup-img" />
        <div class="count">
          <span class="num">
            <count-up class="infor-card-count user-created-count" :id-name="'code_' + '班级总数'"
              :end-val="totalDistrictDataList[1].value" color="#0EFCFF" countSize="18" :countWeight="countWeight"
              :isConvert="isConvert">
            </count-up>
          </span>
          <p>班级总数</p>
        </div>
      </div>
    </div>
    <!--气泡3-->
    <div class="rate-popup rate-popup-three" :title="totalDistrictDataList[3].value">
      <div class="rate-popup-item">
        <img src="../../../assets/images/nanjindataboard/popup-ratate.png" width="100%" height="100%" class="popup-img" />
        <div class="count">
          <span class="num">
            <count-up class="infor-card-count user-created-count" :id-name="'code_' + '学生总数'"
              :end-val="totalDistrictDataList[3].value" color="#0EFCFF" countSize="18" :countWeight="countWeight"
              :isConvert="isConvert">
            </count-up>
          </span>
          <p>学生总数</p>
        </div>
      </div>
    </div>
    <!--气泡4-->
    <div class="rate-popup rate-popup-four" :title="totalDistrictDataList[2].value">
      <div class="rate-popup-item">
        <img src="../../../assets/images/nanjindataboard/popup-ratate.png" width="100%" height="100%" class="popup-img" />
        <div class="count">
          <span class="num">
            <count-up class="infor-card-count user-created-count" :id-name="'code_' + '教师总数'"
              :end-val="totalDistrictDataList[2].value" color="#0EFCFF" countSize="18" :countWeight="countWeight"
              :isConvert="isConvert">
            </count-up>
          </span>
          <p>教师总数</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDistrictSchoolList,
  getNextRegionSchoolInfomation,
  getRegionSchoolInfomation,
  getBureauStatisticsAPI, getQxDataAPI
} from "../../../service/api";

import CountUp from "../../../components/countUp.vue";

export default {
  name: "city-map",
  components: {
    CountUp,
  },
  props: ["token", 'channel', 'areaParams', 'regionId', 'isTowns'],
  data() {
    return {
      map: null, //南京地图
      //地图宽高
      mapStyleObj: {
        width: "100%",
        height: "100%",
      },
      boxWrapStyleObj: {
        height: "0px",
      },
      countWeight: 700,
      isConvert: 1, //是否转换数字
      //显示二级区统计图
      isShowProvince: false,
      geoCoordMap: {},
      //数据信息
      data: [
      ],
      //总区域数据集合
      totalDistrictDataList: [
        {
          name: "学校总数",
          value: 0,
        },
        {
          name: "班级总数",
          value: 0,
        },
        {
          name: "教师总数",
          value: 0,
        },
        {
          name: "学生总数",
          value: 0,
        },
      ],
      //区域数据集合
      districtDataList: [
        {
          name: "学校总数",
          value: 0,
        },
        {
          name: "班级总数",
          value: 0,
        },
        {
          name: "教师总数",
          value: 0,
        },
        {
          name: "学生总数",
          value: 0,
        },
      ],
      mapData: [],
      maxNum: 0,
      provinceMap: null, //省级地图
      provinceMapData: [],
      currentCode: "", //省code
      currentCityCode: "", //市code
      schoolUseData: [], //学校使用数据
      filters: {
        keyWord: "",
      },
      pageParams: {
        page: 1,
        limit: 10,
        total: 0,
        pageCount: 0,
      },
      currentName: ''
    };
  },
  methods: {
    /**
    * @name 获取清徐用户凭证
    */
    async getQxData() {
      let _this = this;
      let url = 'https://qxdata.iclass30.com/xcofficeapi/clientToken/login/client';

      let options = {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: '{"clientId":"dc5c5247918042a3926db807dbb12638","clientSecret":"b9a95e48724948348f125c98a74b5956"}'
      };

      fetch(url, options)
        .then((res) => {
            return res.json();
          })
          .then((data) => {
            _this.getBureauStatistics(data.data.access_token)
          })
        .catch(err => console.error('error:' + err));


    },
    /**
    * @name 获取清徐数据
    */
    async getBureauStatistics(xckj_token) {
      let _this = this;
      let params = {
        xckj_token: xckj_token,
        bureauId: '0c0ddcd2e6834ad4b7f525ee9be9af4b'
      };
      console.log('xckj_token:'+xckj_token);
      let res = await getBureauStatisticsAPI(params);
      _this.totalDistrictDataList = [
        {
          name: "学校总数",
          value: res.schoolCnt || 0,
        },
        {
          name: "班级总数",
          value: res.classCnt || 0,
        },
        {
          name: "教师总数",
          value:res.teacherCnt || 0,
        },
        {
          name: "学生总数",
          value: res.stuCnt || 0,
        },
      ];
    },
    /**
     * @name 获取总数据数据
     */
    getPlatformInformationStats() {
      let _this = this;
      let params = {
        provinceCode: _this.areaParams.provinceCode,
        cityCode: _this.areaParams.cityCode,
        districtCode: _this.areaParams.districtCode,
        regionId: _this.regionId,
        address: '',
        isTowns: _this.isTowns
      };
      getRegionSchoolInfomation(params).then(function (res) {
        _this.totalDistrictDataList = [
          {
            name: "学校总数",
            value: res[0].schoolNum || 0,
          },
          {
            name: "班级总数",
            value: res[0].classNum || 0,
          },
          {
            name: "教师总数",
            value: res[0].teaNum || 0,
          },
          {
            name: "学生总数",
            value: res[0].stuNum || 0,
          },
        ];
      });
    },
    /**
     * @name 获取区域数据
     */
    getNextRegionSchoolInfomationData() {
      let _this = this;
      let params = {
        provinceCode: _this.areaParams.provinceCode,
        cityCode: _this.areaParams.cityCode,
        districtCode: _this.areaParams.districtCode,
        regionId: _this.regionId,
        isTowns: _this.isTowns
      };
      getNextRegionSchoolInfomation(params).then(function (res) {
        _this.data = res.map((item) => {
          return {
            name: _this.isTowns == 1 ? item.address : _this.areaParams.districtCode == '' ? item.districtName : item.cityName,
            code: _this.isTowns == 1 ? '' : _this.areaParams.districtCode == '' ? item.districtCode : item.cityCode,
            value: item.schoolNum,
            districtDataList: [
              {
                name: "学校总数",
                value: item.schoolNum,
              },
              {
                name: "班级总数",
                value: item.classNum,
              },
              {
                name: "教师总数",
                value: item.teaNum,
              },
              {
                name: "学生总数",
                value: item.stuNum,
              },
            ],
          }
        });
      });
    },
    /**
     * 关闭弹窗
     */
    closeWin() {
      this.filters.keyWord = "";
      this.pageParams.total = 0;
      this.pageParams.page = 1;
      this.pageParams.pageCount = 0;
      this.provinceMapData = [];
      this.currentProvinceName = "";
      this.currentProvinceCode = "";
      this.currentCityCode = "";
      this.isShowProvince = false;
    },
    /**
     * 点击查看学校数据展板
     */
    lookSchoolDashBoard(schoolId) {
      let routeData = this.$router.resolve({
        name:
          schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
            ? "cloudschooldataboard"
            : "schooldataboard",
        params: {
          schoolId: schoolId,
        },
        query: {
          tokenId: this.$store.getters.token,
          origin: "chart",
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 翻页
     */
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.queryDistrictSchoolList(this.currentCode);
    },
    /**
     * 查询
     */
    handleSearch() {
      this.pageParams.total = 0;
      this.pageParams.page = 1;
      this.pageParams.pageCount = 0;
      this.queryDistrictSchoolList(this.currentCode);
    },
    /**
     * 处理数据的函数,将经纬度,名称,value结合到一起放入series中的data中
     */
    convertData(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = this.geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          });
        }
      }
      return res;
    },
    /**
     * @name 查看区域地图
     */
    initDirstMap(item) {
      this.districtDataList = item.districtDataList;
      if (this.isTowns == '1') {
        this.currentName = item.name || '';
        this.isShowProvince = true;
      } else {
        this.initDistrictMap(item.name, item);
        this.currentCode = item.code;
      }
      this.queryDistrictSchoolList(item);
    },
    /**
     * 获取区域下的学校列表
     */
    queryDistrictSchoolList(item) {
      let _this = this;
      let params = {
        province: _this.areaParams.provinceCode,
        city: _this.areaParams.cityCode,
        districtId: _this.isTowns == 0 ? _this.currentCode : _this.areaParams.districtCode,
        page: _this.pageParams.page,
        limit: _this.pageParams.limit,
        keyWord: _this.filters.keyWord,
        regionId: _this.regionId,
        address: _this.isTowns == 1 ? _this.currentName : '',
        isTowns: _this.isTowns
      };
      getDistrictSchoolList(params)
        .then(function (res) {
          let data = res.classCountList;
          // _this.handleData(data);
          _this.schoolUseData = data;
          _this.pageParams.total = res.gradeTotal;
          _this.pageParams.pageCount = Math.ceil(
            res.gradeTotal / _this.pageParams.limit
          );
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 处理数据
     */
    handleData(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].classCount = data[i].classCount + 2;
      }
      this.schoolUseData = data;
    },
    /**
     * 动态加载区地图
     */
    initDistrictMap(name, data) {
      let _this = this;
      if (name != "江北新区" && data.code != "320112") {
        var districtData = require("../../../../static/json/南京市/district/" +
          name +
          ".json");
        this.$echarts.registerMap(name, districtData); //注册
        var mapFeatures = this.$echarts.getMap(name).geoJson.features;
        mapFeatures.forEach(function (v) {
          // 地区名称
          var name = v.properties.name;
          // 地区经纬度
          _this.geoCoordMap[name] = v.properties.center;
        });
        //配置样式
        this.optionMap = {
          title: {
            text: name,
            left: "20",
            textStyle: {
              color: "#0EFCFF",
            },
          },
          tooltip: {
            trigger: "item",
            formatter: function (params) { },
          },
          geo: {
            map: name,
            roam: false,
            top: "30%",
            aspectScale: "1.2",
            label: {
              normal: {
                show: false,
                textStyle: {
                  color: "#fff",
                },
              },
              emphasis: {
                show: false,
                color: "#fff",
              },
            },
            itemStyle: {
              normal: {
                areaColor: "#1e62ac",
                borderColor: "#53D9FF",
                borderWidth: 1.3,
                shadowBlur: 15,
                shadowColor: "rgb(58,115,192)",
                shadowOffsetX: 7,
                shadowOffsetY: 6,
              },
              emphasis: {
                areaColor: "#8dd7fc",
                borderWidth: 1.6,
                shadowBlur: 25,
              },
            },
          },
          series: [
            {
              type: "effectScatter",
              coordinateSystem: "geo",
              geoIndex: 0,
              data: _this.convertData(data),
              symbolSize: 12,
              showEffectOn: "render",
              rippleEffect: {
                brushType: "stroke",
              },
              animation: true,
              label: {
                normal: {
                  formatter: "{b}",
                  position: "top",
                  show: true,
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
              itemStyle: {
                normal: {
                  color: "#f4e925",
                  shadowBlur: 10,
                  shadowColor: "#333",
                },
              },
              zlevel: 1,
            },
            {
              name: "categoryChina",
              type: "map",
              geoIndex: 0,
              data: data,
            },
          ],
        };
        var dom = document.getElementById("district_map");
        //得到echarts的实例对象
        var myChart = this.$echarts.init(dom);
        myChart.setOption(this.optionMap);
      }

      _this.$nextTick(() => {
        // 打开弹窗
        _this.isShowProvince = true;
      });
    },
    /**
     * 获取最大数值
     */
    findMaxVal(data) {
      let curMaxNum = 0;
      for (var i = 0; i < data.length; i++) {
        if (curMaxNum < data[i].value) {
          curMaxNum = data[i].value;
        }
      }
      return curMaxNum;
    },
  },
  mounted() {
    let _this = this;
    // 初始化市级地图
    // _this.initCityMap();
    let winHeight = window.innerHeight;
    if (winHeight < 900) {
      winHeight = 938;
    }
    let boxWrapHeight = winHeight - 128 - 10;
    let contentHeight = boxWrapHeight - 20;
    _this.boxWrapStyleObj.height = boxWrapHeight + "px";
    _this.$refs.cityMapRef.style.height = contentHeight + "px";
    // 更新地图
    window.addEventListener("resize", function () {
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let boxWrapHeight = winHeight - 128 - 10;
      let contentHeight = boxWrapHeight - 20;
      _this.boxWrapStyleObj.height = boxWrapHeight + "px";
      _this.$refs.cityMapRef.style.height = contentHeight + "px";
      _this.map.resize();
    });
    if (_this.channel == 'qx') {
      _this.getQxData();
    } else {
      _this.getPlatformInformationStats();
    }

    _this.getNextRegionSchoolInfomationData();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
@import "../../../style/map";

.map-container {
  position: relative;
  box-sizing: border-box;
  padding: 0 22px 0 22px;
}

.dirst-content {
  height: 100%;
  width: vw(700);
  margin: 0 auto;
  padding-top: vw(130);
}

.distri-item {
  width: vw(210);
  height: vw(128);
  line-height: vw(128);
  text-align: center;
  font-size: vw(40);
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #0efcff;
  background-image: url("../../../assets/images/nanjindataboard/dirst-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.jbxq-img {
  width: vw(230);
  height: vw(330);
  margin-top: vw(190);
  margin-left: vw(65);
  background-image: url("../../../assets/images/nanjindataboard/distrist-jbxq.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.jbxq-img:hover {
  width: vw(230);
  height: vw(330);
  margin-top: vw(190);
  margin-left: vw(65);
  background-image: url("../../../assets/images/nanjindataboard/distrist-jbxq-hover.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.panel-box {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  background-image: url("../../../assets/images/map/box-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.map-background {
  background-image: url("../../../assets/images/nanjindataboard/bg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}

.bubble {
  background-image: url("../../../assets/images/nanjindataboard/popup.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.popup-img {
  animation: rota 10s infinite linear;
  -webkit-animation: rota 10s infinite linear;
  -moz-animation: rota 10s infinite linear;
}

.current-area-name {
  position: absolute;
  left: vw(200);
  top: vw(350);
  line-height: vw(20);
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #0efcff;
}
</style>
